import React, {useEffect, useRef, useState} from "react";
import TopBreadcrumbs from "../Surcharge/TopBreadcrumbs";
import {addCompanyBreadcrumb, createTenantsIntegrationBreadcrumb} from "../../../common/data/parties";
import {Card, CardBody, Container, FormFeedback, Input, Row} from "reactstrap";
import SimpleBar from "simplebar-react";
import FileUpload from "../FileUpload";
import {useFormik} from "formik";
import { useLoadingBar } from "../../../components/Common/ProgressBar";
import { useMobileView } from "../../../components/Common/CommonLogic";
import Layout from "../../../store/layout/reducer";
import {useDispatch, useSelector} from "react-redux";
import {GET_NETWORK_INTEGRATION_SUMMARY, GET_TENANTS_APP_CHANEL} from "../../../store/Settings/actiontype";
import {postTenantsAppChanel} from "../../../store/Settings/actions";

const Integrations = () => {
    const dispatch = useDispatch();
    const isMobile = useMobileView();
    const { start, complete, decrease, increase } = useLoadingBar({ height: 3, });
    const [active, setActive] = useState("emailConfigDetails");

    const [libormiChecked, setLibormiChecked] = useState(false);
    const [libormiFieldShown, setLibormiFieldShown] = useState(false);

    const [bhashSmsChecked, setBhashSmsChecked] = useState(false);
    const [bhashSmsFieldShown, setBhashSmsFieldShown] = useState(false);

    const { integrationSummary, getTenantsAppChannel } = useSelector((state) => state?.settings);
    const [visibleFields, setVisibleFields] = useState({});
    const executedRef = useRef(false);

    useEffect(() => {
        dispatch({ type: GET_NETWORK_INTEGRATION_SUMMARY });
        dispatch({ type: GET_TENANTS_APP_CHANEL })
    }, []);


    useEffect(() => {
        //console.log(getTenantsAppChannel, "getTenantsAppChannel");
        //onHandleCheckBoxToggle(13);
        if (!executedRef.current && Array.isArray(getTenantsAppChannel?.content) && getTenantsAppChannel?.content.length > 0) {
            const appChannelIds = [...new Set(getTenantsAppChannel?.content
                .map(item => item.appChannelId)
                .filter(id => id !== null))];
            //console.log(appChannelIds, "appChannelIds");
            appChannelIds.map((item) => onHandleCheckBoxToggle(item));
            executedRef.current = true; // prevent future execution
        }
    }, [getTenantsAppChannel]);

    const onHandleConfig = (configData) => {
        setActive(configData);
    }

    const onHandleEmailSwitch = (prefix) => {
        switch (prefix) {
            case 'libormiConfig':
                setLibormiChecked(!libormiChecked);
                setLibormiFieldShown(!libormiFieldShown);
                setBhashSmsFieldShown(false);
                setBhashSmsChecked(false);
                break;
            case 'bhashSmsConfig':
                setBhashSmsChecked(!bhashSmsChecked);
                setBhashSmsFieldShown(!bhashSmsChecked);
                setLibormiFieldShown(false);
                setLibormiChecked(false);
                break;
            default:
                return;
        }
    }

    const onHandleCheckBoxToggle = (id) => {
        //console.log(id, "onHandleCheckBoxToggle");
        setVisibleFields((prevState) => ({
            ...prevState,
            [id]: !prevState[id], // Toggle the value
        }));
    };

    const emailIntegrationsFormik = useFormik({
        enableReinitialize: true,
        initialValues: Array.isArray(integrationSummary?.content) && integrationSummary?.content.reduce((acc, item) => {
            item?.appChannelIntegrationFields.forEach((field) => {
                acc[`${item.id}_${field.id}`] = (getTenantsAppChannel?.content ?? []).find(
                    tenantItem =>
                        tenantItem.appChannelId === item.id &&
                        tenantItem.globalAppChannelIntegrationFieldsId === field.id
                )?.value || "";
            });
            return acc;
        }, {}),
        onSubmit: (values) => {
            const payload = [];
            integrationSummary?.content.forEach((item) => {
                item?.appChannelIntegrationFields.forEach((field) => {
                    const fieldKey = `${item.id}_${field.id}`;
                    if (values[fieldKey]) {
                        payload.push({
                            appChannelId: item.id, // Get appChannelId dynamically
                            globalAppChannelIntegrationFieldsId: field.id,
                            value: values[fieldKey], // User input
                            status: item.status,
                        });
                    }
                });
            });
            dispatch(postTenantsAppChanel(payload));
            //console.log("Generated Payload:", JSON.stringify(payload, null, 2));
        }
    })

    console.log(integrationSummary);
    


    return (
        <>
            <div className="page-content settings_wrapper">
                <TopBreadcrumbs breadcrumbs={createTenantsIntegrationBreadcrumb}/>
                <Container fluid>
                    <Row>
                        <div className="col-12 col-md-2">
                            <Card className="h-100">
                                <SimpleBar style={{maxHeight: "100%"}}>
                                    <div id="sidebar-menu" className="settings_sidebar">
                                        <ul className="metismenu list-unstyled" id="side-menu">
                                            <li>
                                                <span>
                                                    <a href="#emailConfigDetails"
                                                        onClick={() => {
                                                            onHandleConfig("emailConfigDetails")
                                                        }}
                                                        className={active === "emailConfigDetails" ? "active" : ""}>
                                                        Email
                                                    </a>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </SimpleBar>
                            </Card>
                        </div>

                        {/* ------------------- */}
                        <div className="col-12 col-md-10">
                            <div style={{height: "auto"}}>
                                {/* Comapany details  */}
                                {
                                    active === "emailConfigDetails" &&
                                    <Card id="emailConfigDetails" className="my-4 mb-auto">
                                        <CardBody>
                                            <form onSubmit={emailIntegrationsFormik.handleSubmit}>
                                                {Array.isArray(integrationSummary?.content) && integrationSummary?.content.map((item, index) => {
                                                    return(
                                                        <Card key={index} className="mb-3 shadow-sm">
                                                            <CardBody>
                                                                <div className="row align-items-center">
                                                                    {/* Logo Section */}
                                                                    <div className="col-2 d-flex justify-content-center">
                                                                        <img
                                                                            src={item?.logo}
                                                                            alt={item.appName}
                                                                            className="img-fluid"
                                                                            style={{ height: "60px", width: "auto" }}
                                                                        />
                                                                    </div>

                                                                    {/* App Name & Description */}
                                                                    <div className="col-6 text-start">
                                                                        <h5 className="mb-0 fw-bold">{item.appName}</h5>
                                                                        {item.appDescription && <p className="text-muted small mt-1">{item.appDescription}</p>}
                                                                    </div>

                                                                    {/* Toggle Switch */}
                                                                    <div className="col-4 d-flex justify-content-end">
                                                                        <div className="form-check form-switch toggle-switch">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                checked={visibleFields[item.id]  || false}
                                                                                onClick={() => onHandleCheckBoxToggle(item.id)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Form Inputs - Properly Aligned */}
                                                                {visibleFields[item.id] && (
                                                                    <>
                                                                        <div className="row mt-3" key={`i-${visibleFields[item.id]}`}>
                                                                            <div className="col-2" key={`c-${visibleFields[item.id]}`}></div> {/* Empty Column for Alignment */}
                                                                            <div className="col-10" key={`k-${visibleFields[item.id]}`}>
                                                                                {item?.appChannelIntegrationFields.map((channelItem, channelIndex) => {
                                                                                    return(
                                                                                        <>
                                                                                            <div className="row mb-2 align-items-center" key={channelIndex}>
                                                                                                <label
                                                                                                    htmlFor={`${item.id}_${channelItem.id}`}
                                                                                                    className="col-md-2 col-form-label fw-bold">{channelItem.fieldName}</label>
                                                                                                <div className="col-md-10">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id={`${item.id}_${channelItem.id}`}
                                                                                                        name={`${item.id}_${channelItem.id}`}
                                                                                                        value={emailIntegrationsFormik.values[`${item.id}_${channelItem.id}`] || ""}
                                                                                                        onChange={emailIntegrationsFormik.handleChange}
                                                                                                        onBlur={emailIntegrationsFormik.handleBlur}
                                                                                                        className="form-control"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}

                                                            </CardBody>
                                                        </Card>
                                                    )
                                                })}
                                                <div style={{height: "20px"}}></div>
                                                <div className="mt-4 text-center">
                                                    <div className="row">
                                                        <div className="d-flex justify-content-center">
                                                            <div className="mb-3 mx-3 d-flex justify-content-end">
                                                                <button type="submit" className=" btn btn-primary">
                                                                    Save
                                                                </button>
                                                            </div>
                                                            <div className="mb-3 mx-3 d-flex justify-content-end">
                                                                <button
                                                                    onClick={() => emailIntegrationsFormik.resetForm()}
                                                                    className=" btn btn-primary">
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                        </CardBody>
                                    </Card>
                                }

                                {/* Bussiness Type */}
                                {
                                    active === "whatsappConfigDetails" &&
                                    <Card id="whatsappConfigDetails" className="my-4 mb-auto">
                                        <CardBody>
                                            <Card id="libormi">
                                                <CardBody>
                                                    <div className="row mt-4 justify-content-center">
                                                        <div className="col-12 col-md-8 mb-4">
                                                            <div className={isMobile ? 'row justify-content-center' : 'row justify-content-start'}>
                                                                <div className="d-flex image-placeholder bg-light text-muted justify-content-center">
                                                                    <img src={"https://www.libromi.com/favicon.png"} alt={"libormilogo"} style={{borderRadius: '100%'}} />
                                                                </div>
                                                                <div className="d-flex col-12 col-md-3 mb-3 align-items-end justify-content-center">
                                                                    <h2 className="mb-0">Libormi</h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-4 align-content-center">
                                                            <div className="d-flex align-items-end justify-content-end">
                                                                <div className="form-check form-switch toggle-switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={libormiChecked}
                                                                        onChange={(e) => {
                                                                            onHandleEmailSwitch("libormiConfig");
                                                                        }}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {libormiFieldShown &&
                                                        <>
                                                            <div className="row mt-4 align-items-baseline justify-content-center">
                                                                <div className="col-12 col-md-2 mb-0 align-content-center">
                                                                    <label htmlFor="website" className="form-label">Website</label>
                                                                </div>
                                                                <div className="col-12 col-md-8 mb-0 align-content-center">
                                                                    <input type="text" id="website" className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4 align-items-baseline justify-content-center">
                                                                <div className="col-12 col-md-2 mb-0 align-content-center">
                                                                    <label htmlFor="metabusinesssuite" className="form-label">Meta Business Suite </label>
                                                                </div>
                                                                <div className="col-12 col-md-8 mb-0 align-content-center">
                                                                    <input type="text" id="metabusinesssuite" className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4 align-items-baseline justify-content-center">
                                                                <div className="col-12 col-md-2 mb-0 align-content-center">
                                                                    <label htmlFor="phonenumber" className="form-label">Phone Number</label>
                                                                </div>
                                                                <div className="col-12 col-md-8 mb-0 align-content-center">
                                                                    <input type="text" id="phonenumber" placeholder={"Without using whatsapp number"} className="form-control" />
                                                                </div>
                                                            </div>
                                                        </>
                                                    }

                                                </CardBody>
                                            </Card>
                                            <Card id="bhashsms">
                                                <CardBody>
                                                    <div className="row mt-4 justify-content-center">
                                                        <div className="col-12 col-md-8 mb-4">
                                                            <div className={isMobile ? 'row justify-content-center' : 'row justify-content-start'}>
                                                                <div className="d-flex image-placeholder bg-light text-muted justify-content-center">
                                                                    <img src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdIe4Bxmfo1GDQUO-GD9XdaixqVj5OuBHDVw&s"} alt={"bhashsmslogo"} style={{borderRadius: '100%'}} />
                                                                </div>
                                                                <div className="d-flex col-12 col-md-3 mb-3 align-items-end justify-content-center">
                                                                    <h2 className="mb-0">Bhash Sms</h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-4 align-content-center">
                                                            <div className="d-flex align-items-end justify-content-end">
                                                                <div className="form-check form-switch toggle-switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={bhashSmsChecked}
                                                                        onChange={(e) => {
                                                                            onHandleEmailSwitch("bhashSmsConfig");
                                                                        }}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {bhashSmsFieldShown &&
                                                        <>
                                                            <div className="row mt-4 align-items-baseline justify-content-center">
                                                                <div className="col-12 col-md-2 mb-0 align-content-center">
                                                                    <label htmlFor="apiToken" className="form-label">Server API
                                                                        Token</label>
                                                                </div>
                                                                <div className="col-12 col-md-8 mb-0 align-content-center">
                                                                    <input type="text" id="apiToken" className="form-control" />
                                                                </div>
                                                            </div>
                                                        </>
                                                    }

                                                </CardBody>
                                            </Card>
                                            <div style={{height: "20px"}}></div>
                                            <div className="mt-4 text-center">
                                                <div className="row">
                                                    <div className="d-flex justify-content-center">
                                                        <div className="mb-3 mx-3 d-flex justify-content-end">
                                                            <button
                                                                //onClick={subscriberCreateFormik.handleSubmit}
                                                                type="submit"
                                                                className=" btn btn-primary">
                                                                Save
                                                            </button>
                                                        </div>
                                                        <div className="mb-3 mx-3 d-flex justify-content-end">
                                                            <button
                                                                //onClick={() => subscriberCreateFormik.resetForm()}
                                                                className=" btn btn-primary">
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                }


                                <div style={{height: "200px"}}></div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Integrations;
